var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup47(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.036,
    height: 150.032,
    viewBox: "0 0 150.036 150.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(-431.965 -1829.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1638.127,840.268v51.325a10.674,10.674,0,0,1-21.348,0V875.16a4.081,4.081,0,0,0-4.079-4.07,4.025,4.025,0,0,0-2.86,1.2L1561.432,920.7a10.674,10.674,0,0,1-15.095-15.1l47.724-47.719a4.069,4.069,0,0,0-2.878-6.943h-15.055a10.672,10.672,0,1,1,0-21.344h51.325a10.687,10.687,0,0,1,10.674,10.674",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M1638.127,840.268v51.325a10.674,10.674,0,0,1-21.348,0V875.16a4.081,4.081,0,0,0-4.079-4.07,4.025,4.025,0,0,0-2.86,1.2L1561.432,920.7a10.674,10.674,0,0,1-15.095-15.1l47.724-47.719a4.069,4.069,0,0,0-2.878-6.943h-15.055a10.672,10.672,0,1,1,0-21.344h51.325a10.687,10.687,0,0,1,10.674,10.674",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1638.127,942.953v26a10.683,10.683,0,0,1-10.674,10.67H1498.765a10.684,10.684,0,0,1-10.674-10.67V840.268a10.687,10.687,0,0,1,10.674-10.674h26a10.672,10.672,0,1,1,0,21.344h-.321a15.024,15.024,0,0,0-15.008,15.008v77.328a15.022,15.022,0,0,0,15.008,15.008h77.328a15.022,15.022,0,0,0,15-15.008v-.321a10.674,10.674,0,1,1,21.348,0",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M1638.127,942.953v26a10.683,10.683,0,0,1-10.674,10.67H1498.765a10.684,10.684,0,0,1-10.674-10.67V840.268a10.687,10.687,0,0,1,10.674-10.674h26a10.672,10.672,0,1,1,0,21.344h-.321a15.024,15.024,0,0,0-15.008,15.008v77.328a15.022,15.022,0,0,0,15.008,15.008h77.328a15.022,15.022,0,0,0,15-15.008v-.321a10.674,10.674,0,1,1,21.348,0",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47);
export default __webpack_public_path__ + "static/media/Group 47.db4e7cbb7709873262a7abfc630d8465.svg";
export { ForwardRef as ReactComponent };